export default __webpack_public_path__ + "52d95504d9dfce6752a412f95913842a.svg";